import { ToastContainer, toast } from "react-toastify";
import React, { useState } from "react";
import { formatDate } from "../../utilities/CommonUtilities";
import "rsuite/DatePicker/styles/index.css";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";

function CustomDatePicker({ setDateFilter, filterDate, isLoading }) {
  const today = new Date();
  const todayDate = new Date(today.setHours(0, 0, 0, 0));
  const [endDate, setEndDate] = useState(
    filterDate.endDate ? new Date(filterDate.endDate) : new Date()
  );
  const [startDate, setStartDate] = useState(
    filterDate.startDate ? new Date(filterDate.startDate) : new Date()
  );
  const handleStartDateChange = (date) => {
    const selectedDate = new Date(date.setHours(0, 0, 0, 0));
    if (!selectedDate) {
      toast.error("Please select a start date.");
      return;
    }
    if (selectedDate > todayDate) {
      toast.error("Start date cannot be in the future.");
      return;
    }
    if (endDate && selectedDate >= endDate) {
      const oneMonthAhead = new Date(date);
      oneMonthAhead.setMonth(oneMonthAhead.getMonth() + 1);
      const newEndDate = oneMonthAhead > todayDate ? todayDate : oneMonthAhead;
      setEndDate(newEndDate);
      setStartDate(selectedDate);

      setDateFilter((prev) => ({
        ...prev,
        startDate: selectedDate,
        endDate: newEndDate,
      }));
      // toast.error("Start date must be before the end date.");
      return;
    }

    setStartDate(selectedDate);
    setDateFilter((prev) => ({ ...prev, startDate: selectedDate }));
    toast.success("Start date updated.");
  };

  const handleEndDateChange = (date) => {
    const selectedDate = new Date(date.setHours(0, 0, 0, 0));

    if (!selectedDate) {
      toast.error("Please select an end date.");
      return;
    }
    if (selectedDate > todayDate) {
      toast.error("End date cannot be in the future.");
      return;
    }
    if (startDate && selectedDate <= startDate) {
      toast.error("End date must be after the start date.");
      return;
    }

    setEndDate(selectedDate);
    setDateFilter((prev) => ({ ...prev, endDate: selectedDate }));
    toast.success("End date updated.");
  };

  return (
    <>
      <div className="d-flex align-items-center border border-2 py-1 px-2  bg-white rounded  mx-2 ">
        <ToastContainer />

        <DatePicker
          selected={new Date(filterDate.startDate)}
          value={new Date(filterDate.startDate)}
          onChange={handleStartDateChange}
          maxDate={new Date()}
          minDate={new Date("2018-01-01")}
          format="MM/dd/yyyy"
          className="col-12 border-1 rounded"
          placeholder="Start Date"
          size="sm"
          strictParsing
          disabled={isLoading}
        />
        <div className="mx-2">
          <i className="fa-solid fa-arrow-right" />
        </div>
        <DatePicker
          selected={new Date(filterDate.endDate)}
          value={new Date(filterDate.endDate)}
          onChange={handleEndDateChange}
          maxDate={new Date()}
          minDate={new Date("2018-01-01")}
          format="MM/dd/yyyy"
          className="col-12 border-1 rounded "
          placeholder="End Date"
          size="sm"
          strictParsing
          disabled={isLoading}
        />
      </div>
    </>
  );
}
export default CustomDatePicker;
